/**
 * Coerce a notification distance coming from serialized hike JSON into a
 * number or null. Rails decimal columns serialize to JSON as strings
 * ("0.2"), and sending a string back into the GraphQL Float argument
 * fails coercion ("Could not coerce value \"0.2\" to Float").
 */
export function normalizeNotificationDistance(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const num = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(num) ? num : null;
}
